import Vue from "vue";
import SmartCanvas from "./SmartCanvas.vue";
import store from './stores';
import Vuebar from "vuebar"; //scrollbar
// import "~bootstrap/scss/bootstrap";
// import "@/assets/css/variables.scss";
// import "@/assets/css/_fonts.scss";

// import '@/assets/css/_base.scss'; 
import {Chrome} from 'vue-color';
import 'webpack-jquery-ui/draggable';

import NotifyModal from './../global/modals/NotifyModal';
import ActionModal from './../global/modals/ActionModal';
import ErrorMessage from '@/global/modals/ErrorMessage';

Vue.component('notify-modal', NotifyModal);
Vue.component('action-modal', ActionModal);
Vue.component('error-message', ErrorMessage);

Vue.use(Vuebar);

Vue.component('chrome-picker', Chrome);

/* GlOBALS */
Vue.prototype.API_HOST     = process.env.VUE_APP_API_HOST;
Vue.prototype.BARD_HOST    = process.env.VUE_APP_BARD_HOST;
Vue.prototype.LOGIN_HOST   = process.env.VUE_APP_LOGIN_HOST;
Vue.prototype.GALLERY_HOST = process.env.VUE_APP_GALLERY_HOST;
Vue.prototype.AVATARS      = process.env.VUE_APP_AVATARS_HOST;

export function initSmartCanvas(el, options = {}) {
   if (!el) return null;
 
   let rootComponent = SmartCanvas;
 
   return new Vue({
      el,
      store: store,
      // created() {
      //    this.setInstRecid({
      //       instanceRecid: el.dataset.instanceRecid,
      //    });
      // },
      render(createElement) {
         return createElement(rootComponent);
      },
   });
}


/* DIRECTIVES */

//directive for running methods after clicking away from something.
//used to hide dropdowns after clicking away as well as other related elements
Vue.directive('click-outside', {
   bind: function (el, binding, vnode) {
      el.event = function (event) {
         if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
         }
      };
      document.body.addEventListener('click', el.event)
   },
   unbind: function (el) {
      document.body.removeEventListener('click', el.event)
   },
});


/* MIXINS */
Vue.mixin({
   methods: {
      isAPILoginError(data) {
         if (data.message) {
            if (data.message.includes('Invalid or missing token') ||
                  data.message.includes('Session has expired')) {
               return true;
            }
         }
      },

      getAssetString(assetType) {
         let assetStr;
         switch(parseInt(assetType)) {
            case 1: 
               assetStr = 'image';
               break;
            case 2:
               assetStr = 'movie';
               break;
            case 3:
               assetStr = 'audio';
               break;
            case 6:
               assetStr = 'feeds';
               break;
            case 8:
               assetStr = 'weblink';
               break;
            case 10:
               assetStr = 'instance';
               break;
            case 11:
               assetStr = 'block';
               break;
            default:
               assetStr = 'image';
               break;
         }
         return assetStr;
      },

      getUserRole() {
         return new Promise((resolve, reject) => {
            $.post(this.BARD_HOST + '/user/role',
               {
                  'token'      : localStorage.getItem('token')
               },
               function(data) {
                  resolve(data.roleId);
               }
            ).fail(function(e) {
               reject(e);
            });
         });
      },
   }
 })

//  TEMP
// new Vue({
//    store,
//    render: h => h(SmartCanvas)
// }).$mount("#app");
 